import React, { createContext, useState, useContext, useEffect } from 'react';
import { companyAPI } from '../services/api';

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCompanyData = async () => {
    try {
      setLoading(true);
      const response = await companyAPI.get();
      setCompany(response.data.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching company data:', err);
      setError('Failed to load company data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const refreshCompanyData = () => {
    fetchCompanyData();
  };

  const value = {
    company,
    loading,
    error,
    refreshCompanyData
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};